import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4 9h4a1 1 0 0 0 1-1V4m11 5h-4a1 1 0 0 1-1-1V4M4 15h4a1 1 0 0 1 1 1v4m11-5h-4a1 1 0 0 0-1 1v4"
    }, null, -1)
  ]))]))
}
export default { render: render }